var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class USwitch {
    constructor(log) {
        this.responseHeaders = {
            'okhttp-response-source': 'NETWORK 200',
            'keep-alive': 'timeout=60',
            'cache-control': 'no-store',
            'okhttp-selected-protocol': 'http/1.1',
            'content-type': 'text/xml;charset=UTF-8',
        };
        this.state = {
            ADCs: {
                'ADCin1-i': 0,
            },
            GPIOs: {
                'GPIO1-i': false,
                'GPIO2-i': false,
                'GPIO3-i': false,
            },
            Relays: {
                'Relay1-i': false,
                'Relay2-i': false,
            },
        };
        this.asyncHandlers = [
            {
                name: 'getAllGpioValues',
                path: /\/UHCapi.xml\?cmd=gpio&GetAll/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, 'GPIOs');
                }),
            },
            {
                name: 'getAllNames',
                path: /\/UHCapi.xml\?GetAllNames/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeNameResponse(req);
                }),
            },
            {
                name: 'getAllRelayValues',
                path: /\/UHCapi.xml\?cmd=relay&GetAll/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, 'Relays');
                }),
            },
            {
                name: 'getGpioValue',
                path: /\/UHCapi.xml\?cmd=gpio&(.+)/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, 'GPIOs', match[1]);
                }),
            },
            {
                name: 'getRelayValue',
                path: /\/UHCapi.xml\?cmd=relay&(.+)/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, 'Relays', match[1]);
                }),
            },
            {
                name: 'setRelayValue',
                path: /\/UHCapi.xml\?cmd=relay&(.+)=(\d)/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const name = match[1];
                    const relayValue = match[2] === '1';
                    this.state.Relays[name] = relayValue;
                    return this.makeResponse(req, 'Relays', name);
                }),
            },
        ];
    }
    makeNameResponse(request) {
        const resultString = ['<?xml version="1.0" encoding="UTF-8"?><i>'];
        for (const [key, value] of Object.entries(this.state)) {
            resultString.push(`<${key}>`);
            if (typeof value === 'object') {
                for (const key1 of Object.keys(value)) {
                    resultString.push(`<${key1}>${key1}</${key1}>`); // by default the key is the name
                }
            }
            resultString.push(`</${key}>`);
        }
        resultString.push('</i>');
        return {
            status: 200,
            headers: this.responseHeaders,
            data: resultString.join(''),
        };
    }
    makeResponse(request, ioType, name) {
        var _a;
        const resultString = ['<?xml version="1.0" encoding="UTF-8"?><i>'];
        for (const [key, value] of Object.entries((_a = this.state[ioType]) !== null && _a !== void 0 ? _a : {})) {
            if (name === undefined) {
                resultString.push(`<${key}>${value ? 'On' : 'Off'}</${key}>`);
            }
            else if (name === key) {
                resultString.push(`<${key}>${value ? 'On' : 'Off'}</${key}>`);
                break;
            }
        }
        resultString.push('</i>');
        return {
            status: 200,
            headers: this.responseHeaders,
            data: resultString.join(''),
        };
    }
}
USwitch.emulatorType = 'httpRequestEmulator';
USwitch.key = '-NZ7IIdHzzRXWg-sMQ6K';
